import { Layout, useMobile } from '@sonnen/web-ui';
import { useAuth } from '@sonnen/web-utils/hooks';
import { useEffect } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import { PageBackground } from '../../types';
import styles from './Home.module.css';
import HomeCard from './HomeCard/HomeCard';

const Home = () => {
  const { user: authenticatedUser } = useAuth();
  const { setCurrentBackground } = useAppContext();
  const mobile = useMobile();

  if (authenticatedUser) return null;

  useEffect(() => {
    if (!mobile) setCurrentBackground(PageBackground.HOME);
  }, [setCurrentBackground]);

  return (
    <div className={styles.homePage} data-testid="home-page">
      <Layout centerVertically backgroundColor="none">
        <div className={styles.cardsWrapper}>
          <HomeCard i18nScope="customer" />
          <HomeCard i18nScope="visitor" />
        </div>
      </Layout>
    </div>
  );
};

export default Home;
